import { render, staticRenderFns } from "./PorletInformes.vue?vue&type=template&id=659ba16c"
import script from "./PorletInformes.vue?vue&type=script&lang=js"
export * from "./PorletInformes.vue?vue&type=script&lang=js"
import style0 from "./PorletInformes.vue?vue&type=style&index=0&id=659ba16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports